import React, { useState, useEffect } from "react";
import { array, shape } from "prop-types";
import { RichText, Date } from "prismic-reactjs";
import style from "./style";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { useRouter } from 'next/router'
import PersonItem from "../../components/PersonItem";
import TitleSubtitle from "../../components/TitleSubtitle";
import CategoryTag from "../../components/CategoryTag";
import CustomLink from "../../components/CustomLink";
import { useLayout } from "../../utils/layout-context";

const section = {
  maxWidth: "600px",
  margin: "4em auto",
  textAlign: "center",
};

const h2 = {
  color: "#8592e0",
};
const dateOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const AllBlogs = ({
  classes,
  allBlogs,
  allBlogsBasedOnTopic,
  allBlogCategories,
  params,
  blogCategoryData,
}) => {
  const {layout}=useLayout()
  const [results, setResults] = useState(allBlogs.results);
  
  return (
    layout?<div className={classes.featuredBlogs}>
      <Container maxWidth="lg">
        {blogCategoryData && blogCategoryData.data && (
          <TitleSubtitle
            title={RichText.asText(blogCategoryData.data.topic_name)}
            subtitle={RichText.asText(blogCategoryData.data.subtitle)}
            showClass={false}
          />
        )}

        <Grid
          container
          spacing={4}
          direction="row"
          justify="center"
          alignItems="center"
          className="CategoryTagWrapper"
        >
          <Grid item md={2} key="random">
            <CustomLink link={{ type: "learn" }}>
              <CategoryTag
                selected={true}
                CategoryTagTitle={RichText.asText(layout.blog_view_all_button_text)}
                showIcon={false}
              />
            </CustomLink>
          </Grid>
          {allBlogCategories.results.map((category, index) => {
            return (
              <Grid item md={2} key={index}>
                <CustomLink link={category}>
                  <CategoryTag
                    CategoryTagTitle={RichText.asText(
                      category.data.topic_name
                    )}
                    showIcon={false}
                  />
                </CustomLink>
              </Grid>
            );
          })}
        </Grid>
        <Grid
          container
          spacing={4}
          direction="row"
          justify="center"
          className="featureBlogsContainer"
        >
          {allBlogs.map((blog, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={index == 0 || index == 1 ? 6 : 4}
                key={index}
              >
                <PersonItem
                  link={blog}
                  showTag={
                    blog.data.blog_topics && blog.data.blog_topics.length > 0
                  }
                  tag={
                    blog.data.blog_topics &&
                    blog.data.blog_topics.length > 0 &&
                    blog.data.blog_topics[0].blog_topic.data &&
                    blog.data.blog_topics[0].blog_topic.data.topic_name ? (
                      <CustomLink link={blog.data.blog_topics[0].blog_topic}>
                        {RichText.asText(
                          blog.data.blog_topics[0].blog_topic.data.topic_name
                        )}
                      </CustomLink>
                    ) : null
                  }
                  bannerImageSrc={blog.data.featured_image.url}
                  bannerImageAlt={blog.data.featured_image.alt}
                  name={RichText.asText(blog.data.title)}
                  title={Date(blog.data.date).toLocaleDateString(
                   useRouter().locale,
                    dateOptions
                  )}
                />
              </Grid>
            );
          })}
        </Grid>
        
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.pagination}
        >
          <Grid item>
            {params.idx > 1 && (
              <CustomLink
                link={{
                  type: "blog_topic",
                  uid: params.category,
                  idx: +params.idx - 1,
                }}
              >
                <Button variant="contained" color="primary" size="small">
                  {RichText.asText(layout.blog_previous_button)}
                </Button>
              </CustomLink>
            )}
            {params.idx < allBlogsBasedOnTopic.length / 25 && (
              <CustomLink
                link={{
                  type: "blog_topic",
                  uid: params.category,
                  idx: +params.idx + 1,
                }}
              >
                <Button variant="contained" color="primary" size="small">
                  {RichText.asText(layout.blog_next_button)}
                </Button>
              </CustomLink>
            )}
          </Grid>
        </Grid>

      </Container>
    </div>:<div>...Loading</div>
  );
};

AllBlogs.propTypes = {
  slice: shape({
    primary: shape({
      title: array.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withStyles(style)(AllBlogs);
